import useResource from "hooks/resources"

export function useTagCategories(instrument) {
  return useResource({
    resource: "tagCategories",
    url: () => {
      if (!instrument.id) {
        return null
      }
      return {
        id: `tagCategories-${instrument.id}`,
        query: `query ($portfolioId: String!) {
          portfolio(id: $portfolioId) {
            tagCategories {
              id
              name
            }
          }
        }`,
        variables: { portfolioId: instrument.id },
      }
    },
  }, ["portfolio", "tagCategories"])
}
